module.exports = __webpack_public_path__ + "img/indicator_2.31f8f31a.png";